import { Role } from "../../../api/roles/types";

/**
 * Centralized user-facing copy for the role-management page.
 *
 * This repo has no dedicated i18n framework yet, so — per the project rule that
 * feature text must not be hardcoded inline — every label/message the page
 * renders is sourced from this single module and interpolated with
 * `formatMessage`. When a real i18n library is adopted repo-wide, this object
 * is the natural seed for the default-locale catalog.
 */
export const roleManagementStrings = {
  sidebarLabel: "Role Management",
  pageTitle: "Role Management",
  search: {
    sectionTitle: "Manage Admin Roles",
    inputLabel: "Search customer",
    inputPlaceholder: "Email address",
    submitButton: "Search roles",
  },
  results: {
    heading: "Current roles for {email}",
    noRoles: "This customer has no admin roles.",
    grant: "Grant",
    revoke: "Revoke",
    granted: "Granted",
    notGranted: "Not granted",
  },
  roleLabels: {
    admin: "Admin",
    "super-admin": "Super Admin",
  } as Record<Role, string>,
  messages: {
    loadError: "Could not load roles for {email}. Please try again.",
    grantSuccess: "Granted {role} to {email}.",
    revokeSuccess: "Revoked {role} from {email}.",
    grantError: "Could not grant {role} to {email}. Please try again.",
    revokeError: "Could not revoke {role} from {email}. Please try again.",
    missingActor:
      "Your back-office session email is unavailable. Please sign in again before changing roles.",
  },
} as const;

/**
 * Replaces `{token}` placeholders in a message with the provided values.
 * Unknown tokens are left intact so missing interpolation is visible rather
 * than silently dropped.
 */
export const formatMessage = (
  template: string,
  vars: Record<string, string> = {}
): string =>
  template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : match
  );
